import { render, staticRenderFns } from "./inventory_pending.vue?vue&type=template&id=ba8fe292&scoped=true&"
import script from "./inventory_pending.vue?vue&type=script&lang=js&"
export * from "./inventory_pending.vue?vue&type=script&lang=js&"
import style0 from "./inventory_pending.vue?vue&type=style&index=0&id=ba8fe292&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba8fe292",
  null
  
)

export default component.exports